module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Medium-fc0337b9cf1cce2e6e1ec2bfd1daab86.woff2";